import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "media" }

import { watch, reactive, withDefaults, ref } from 'vue';
import { Bar } from '@antv/g2plot';
import type { StoreType } from '../types';


const __default__ = {
  name: 'MediaChar',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    dataSource: { default: () => ({
      vid: 0,
      doc: 0,
      pic: 0,
      used: 0,
      unused: 0,
      total: 0,
      status: 0,
    }) }
  },
  setup(__props: any) {

const props = __props as { dataSource: StoreType };


const mediaCharData = reactive([
  {
    name: '剩余',
    value: 100,
    type: '资源库',
  },
  {
    name: '图片',
    value: 0,
    type: '资源库',
  },
  {
    name: '文档',
    value: 0,
    type: '资源库',
  },
  {
    name: '视频',
    value: 0,
    type: '资源库',
  },
]);
const charRender = () => {
  const bar = new Bar('media', {
    data: mediaCharData,
    // isPercent: true,
    isStack: true,
    xField: 'value',
    yField: 'type',
    seriesField: 'name',
    // padding: [-45, 0, 0, 0],
    height: 60,
    xAxis: false,
    yAxis: false,
    minBarWidth: 18,
    maxBarWidth: 18,
    // 自定义颜色 绿 黄 蓝 灰
    color: ['#00CCB0', '#FF9337', '#1989FA', '#F0F2F5'],
    legend: {
      position: 'bottom-left',
      // offsetY: 10,
      marker: {
        symbol: 'circle',
      },
    },
  });

  bar.render();
};
watch(props.dataSource, () => {
  const data = props.dataSource;
  mediaCharData[0].value = data.unused;
  mediaCharData[1].value = data.pic;
  mediaCharData[2].value = data.doc;
  mediaCharData[3].value = data.vid;
  charRender();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})